export const isUserAuthoredFilter = (filter) => !filter.source;
export const isEnabledUserAuthoredFilter = (filter) => !filter.source && !filter.isDisabled;
//# sourceMappingURL=adhoc-filter-utils.js.map